// Helpers for the "login -> return -> sync" flow.

const SYNC_AFTER_AUTH_KEY = 'syncAfterAuth';
const RETURN_AFTER_AUTH_KEY = 'returnAfterAuth';
const SYNC_AFTER_AUTH_NONCE_KEY = 'syncAfterAuthNonce';

function generateNonce() {
  // crypto.randomUUID is not supported in some older WebViews.
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (crypto as any).randomUUID() as string;
  }
  return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function startSyncAfterAuth(returnTo: string) {
  sessionStorage.setItem(SYNC_AFTER_AUTH_KEY, 'true');
  sessionStorage.setItem(RETURN_AFTER_AUTH_KEY, returnTo);
  sessionStorage.setItem(SYNC_AFTER_AUTH_NONCE_KEY, generateNonce());
}

export function getSyncAfterAuthState() {
  return {
    enabled: sessionStorage.getItem(SYNC_AFTER_AUTH_KEY) === 'true',
    nonce: sessionStorage.getItem(SYNC_AFTER_AUTH_NONCE_KEY) || null,
    returnTo: sessionStorage.getItem(RETURN_AFTER_AUTH_KEY) || null,
  };
}

export function clearSyncAfterAuthState() {
  sessionStorage.removeItem(SYNC_AFTER_AUTH_KEY);
  sessionStorage.removeItem(SYNC_AFTER_AUTH_NONCE_KEY);
}
